import { styled } from '@mui/material'
import ApostleBountiesRoot from '@src/components/apostles/bounty/ApostleBountiesRoot'
import EmporiumSecNavBar from '@src/components/navigationBar/secondary/EmporiumSecNavBar'
import ApostlesThirdNavBar from '@src/components/navigationBar/third/ApostleThirdNavBar'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import { NextPage } from 'next'
import { useEffect } from 'react'

const StyledApostleBountiesRoot = styled(ApostleBountiesRoot)`
  height: calc(100vh - 116px);
  .Custom-Main-Panel-Container {
    .Custom-Main-Panel {
      .Custom-List-Container {
        width: 100%;
        max-width: 1160px;
      }
    }
  }
`

const ApostleBountiesPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<EmporiumSecNavBar index={1} />)

    return () => setupBar(null)
  }, [setupBar])

  return <StyledApostleBountiesRoot thirdNavBar={<ApostlesThirdNavBar />} />
}

type Props = {}

export default ApostleBountiesPage
